import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export const showToast = (config: {
  title?: string;
  text: string;
  icon: "success" | "error" | "warning" | "info" | "question";
  timer?: number;
}) => {
  MySwal.fire({
    toast: true,
    position: "top-right",
    showConfirmButton: false,
    timer: config.timer || 3000,
    timerProgressBar: true,
    icon: config.icon,
    title: config.title,
    text: config.text,
    showCloseButton: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
    customClass: {
      popup: "colored-toast",
    },
  });
};
